// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { observable, action, makeObservable } from 'mobx';

// data
import { Program } from 'models';
import { ProgramSource } from '../sources';

export class ProgramStore extends Store {
  public forcedLive;

  constructor(private programSource: ProgramSource, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    makeObservable(this, {
      forcedLive: observable,
    });
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.programSource, data.programSource);
  }

  @action
  public getPrograms(): Promise<Program[]> {
    return this.programSource.getPrograms();
  }

  @action
  public getProgram(programName: string): Program {
    return this.programSource.getProgram(programName);
  }

  @action
  public setForcedLive = (program: string) => {
    this.forcedLive = program;
  };
}
